import i18next from "i18next";
/**
 * Locales where the numeric value appears BEFORE the currency symbol
 * (e.g. "100 EUR" in German). German is the ONLY value-first locale;
 * every other resolved language renders the symbol BEFORE the value.
 */
const VALUE_FIRST_LOCALES = ["de"];
/**
 * Resolves the active locale language code (lowercase, without region suffix).
 * Follows the same resolution chain used by formatPrice.ts.
 */
const resolveLanguage = () => {
    const raw = (typeof window !== "undefined"
        ? sessionStorage.getItem("i18nextLng")
        : "") ||
        i18next.language ||
        "en";
    return raw.split("-")[0].toLowerCase();
};
/**
 * Combines a currency symbol (e.g. "US$", "EUR") with a formatted numeric value
 * in the locale-aware order, ALWAYS separated by a space.
 *
 * - Value-first locale (German only — `de`, `de-DE`): "100 EUR"
 * - Symbol-first (every other resolved language):     "US$ 100"
 */
export const formatCurrencyWithSymbol = (symbol, value) => {
    const lang = resolveLanguage();
    const strValue = typeof value === "number" ? String(value) : value;
    if (VALUE_FIRST_LOCALES.includes(lang)) {
        return `${strValue} ${symbol}`;
    }
    return `${symbol} ${strValue}`;
};
